:host {
    --normal-opacity: 0.9;
    --spinner-dim: 165px;
    --spinner-stroke: 14px;
    --spinner-duration: 1000ms;
    --spinner-duration-real: calc(var(--spinner-duration) - 150ms);
    --spinner-delay: 100ms;

    position: absolute;
    width: var(--spinner-dim);
    height: var(--spinner-dim);
    // centrar exactamente en la punta del mouse
    margin-left: calc(var(--spinner-dim) / -2);
    margin-top: calc(var(--spinner-dim) / -2);
    pointer-events: none;
    z-index: 2000;
    display: none;
}

:host(.visible) {
    display: block;
}

.glow {
    position: absolute;
    inset: -20%;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(99, 143, 255, 0.4) 0%, rgba(99, 143, 255, 0.16) 45%, rgba(99, 143, 255, 0) 72%);
    filter: blur(3px);
    opacity: 0;
    transform: scale(0.6);
}

.ring {
    opacity: var(--normal-opacity);
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    // el barrido del progreso inicia arriba en vez del punto por defecto (3 en punto)
    transform: rotate(-90deg);
}

.ring-track {
    fill: none;
    stroke: rgba(255, 255, 255, 0.18);
    stroke-width: var(--spinner-stroke);
}

.ring-progress {
    fill: none;
    stroke-width: var(--spinner-stroke);
    stroke-linecap: round;
    opacity: 0;
}

// ocultar ring-track si .ring-progress no tiene .animate
.glow:not(.animate)+.ring>.ring-track {
    opacity: 0;
}

.glow.animate {
    animation: lasso-glow-in var(--spinner-duration-real) cubic-bezier(0.4, 0, 0.2, 1) forwards;
    animation-delay: var(--spinner-delay);
}

.ring-progress.animate {
    animation: lasso-ring-sweep var(--spinner-duration-real) linear forwards,
        lasso-ring-fade var(--spinner-duration-real) ease-out forwards;
    animation-delay: var(--spinner-delay);
}

// Efecto final cuando el barrido completa su recorrido sin ser interrumpido
.glow.complete {
    animation: lasso-glow-burst 420ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.ring-progress.complete {
    animation: lasso-ring-burst 420ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes lasso-glow-burst {
    0% {
        opacity: 1;
        transform: scale(1);
    }

    100% {
        opacity: 0;
        transform: scale(5);
    }
}

@keyframes lasso-ring-burst {
    0% {
        opacity: var(--normal-opacity);
        stroke-width: var(--spinner-stroke);
        filter: none;
    }

    40% {
        opacity: var(--normal-opacity);
        stroke-width: calc(var(--spinner-stroke) * 1.8);
        filter: drop-shadow(0 0 6px rgb(156, 92, 246));
    }

    100% {
        opacity: 0;
        stroke-width: 0;
        filter: none;
    }
}

@keyframes lasso-glow-in {
    0% {
        opacity: 0;
        transform: scale(0.6);
    }

    60% {
        opacity: 1;
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes lasso-ring-fade {
    0% {
        opacity: 0;
    }

    15% {
        opacity: var(--normal-opacity);
    }

    100% {
        opacity: var(--normal-opacity);
    }
}

@keyframes lasso-ring-sweep {
    from {
        // el valor real de stroke-dashoffset inicial se fija inline (circunferencia del anillo)
        stroke-dashoffset: var(--spinner-circumference);
    }

    to {
        stroke-dashoffset: 0;
    }
}